module.exports = __webpack_public_path__ + "img/tickets.43e59c3d.svg";